import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalController, NavController, ToastController} from '@ionic/angular';
import {AccountBalanceService, NotificationsService} from '@wlp/ui-bs-cashin';
import {
  BilletResponse,
  BilletService,
  ExtractService,
  PaymentLotDetailBillet,
  PaymentLotService,
  PaymentLotTypeLotEnum,
  transactionSchedule,
  TransferService
} from '@wlp/ui-bs-cashout';
import {UserInfoService} from '@wlp/ui-bs-login';
import {UserInfoProfile} from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import {UiBsMyDataService} from '@wlp/ui-bs-my-data';
import {UiBsTranslateService} from '@wlp/ui-bs-translate';
import {UICHeaderUserInfoService} from '@wlp/ui-c-header-user-info';
import * as moment from 'moment';
import {of, Subject} from 'rxjs';
import {catchError, takeUntil, tap} from 'rxjs/operators';
import {LayoutConfigModel} from 'src/app/core/layout/models/layout-config.model';
import {LayoutConfigService} from 'src/app/core/layout/services/layout-config.service';
import {LoadingService} from '../../../../../../../../core/layout/services/loading.service';
import {ModalAlertComponent} from '../../../../../modals/modal-alert/modal-alert.component';
import {ModalExtractReviewComponent} from '../../../../../modals/modal-extract-review/modal-extract-review.component';
import {ModalTokenComponent} from '../../../../../modals/modal-token/modal-token.component';
import {
  ModalAlertBilletTaxesComponent
} from 'src/app/views/themes/sentinel/modals/modal-alert-billet-taxes/modal-alert-billet-taxes.component';
import {AbstractCashOut} from '../../abstract-cash-out';
import {HttpErrorResponse} from '@angular/common/http';

export interface ListData {
  name: string;
  value: string;
}

export interface Data {
  datePay: string;
  amountPaid: string;
  discount: string;
  interest: string;
  fine: string;
  totalPay: string;
  dateExpiration: string;
  transactionIdConsult: string;
}

@Component({
  selector: 'app-billet',
  templateUrl: './billet.page.html',
  styleUrls: ['./billet.page.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BilletPage extends AbstractCashOut implements OnInit, OnDestroy {

  public iconName: string | 'eye-off-outline' | 'eye-outline';
  public showBLC = false;
  public balance: string;
  public balanceResponse: any;

  public flagDisplayCard: boolean;
  public flagDisplayNotification: boolean;
  public messages = [];

  public billetForm: FormGroup;
  public billetResumeForm: FormGroup;
  public billetExtractForm: FormGroup;

  public step2 = false;
  public value: string;
  public editable = false;
  public maxPayment: number;
  public minPayment: number;
  public listData1: ListData[];
  public listData2: ListData[];

  public step3 = false;
  public data: Data;
  public listData3: ListData[];
  public listData4: ListData[];

  public balanceSubject$: string;

  private destroy$: Subject<null> = new Subject();

  public brand: string;

  public wlName: string;
  public showBrand: boolean;

  public readonly OPERATION: string = '112';
  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;

  private param: object;
  private permitTransaction: boolean = false;
  private readonly PERMIT_OPERATION: string = '3';
  public initialDate: any;
  public datePickerConfig: any;
  private disableDays: string;
  private datesSchedule: transactionSchedule;
  private dateTransfer: any;
  private dateExpiration: any;
  public billetExpireded: boolean = false;
  private transferScheduled: boolean;
  public titleExtract: string;
  private valuePayment: number = 0;
  public textActionButton: string = '';
  public titleHeader: string = 'CASH_OUT.BILLET.HEADER.TITLE';
  public paymentDataEmmittedVoucher: any;
  public isEmittedVoucher: boolean = false;
  private consultBilletResponse: BilletResponse;

  public isValidDay: any;
  public isDateExpirated: any;

  constructor(
    private navCtrl: NavController,
    private router: Router,
    private modalController: ModalController,
    private service: BilletService,
    private accountBalanceService: AccountBalanceService,
    private notificationsService: NotificationsService,
    private toastController: ToastController,
    public loadingService: LoadingService,
    protected userInfoService: UserInfoService,
    private headerService: UICHeaderUserInfoService,
    private layoutConfigService: LayoutConfigService,
    private myDataService: UiBsMyDataService,
    private translate: UiBsTranslateService,
    private route: ActivatedRoute,
    private transferService: TransferService,
    private activatedRoute: ActivatedRoute,
    protected extractService: ExtractService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private paymentLotService: PaymentLotService,
  ) {
    super(paymentLotService, cdr, modalController, navCtrl);

    this.brand = this.layoutConfigService.getConfig('wlTheme.header.billet.brand.logo');
    this.wlName = this.layoutConfigService.getConfig('wlTheme.wlName');
  }

  public codeOperation(): string {
    return this.OPERATION;
  }

  public ngOnInit() {
    this.textActionButton = 'CASH_OUT.BILLET_RESUME.BUTTONS.PAY';
    this.titleHeader = 'CASH_OUT.BILLET.HEADER.TITLE';
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);

    this.loadUser(true);
    this.showBrand = true;

    this.billetForm = this.service.getBilletForm();
    this.billetResumeForm = this.service.getBilletResumeForm();
    this.billetExtractForm = this.service.getBilletExtractForm();

    this.iconName = 'eye-off-outline';
    this.balance = '';

    this.flagDisplayCard = false;
    this.flagDisplayNotification = false;

    this.accountBalanceService
      .getBalanceSubject()
      .pipe(
        takeUntil(this.destroy$),
        tap((data) => {
          this.balanceSubject$ = String(data);
        })
      )
      .subscribe();

    this.route.params.subscribe((params) => {

      if (params && params.code) {
        this.f('brCode').patchValue(params.code);
        this.validBarCode();
      }
    });

    this.behaviorToggle.next(this.toggleLotPayment);

    // this.route.queryParams.subscribe((params) => {
    //   console.log('params', params);
    //
    //   if (params && params.lot != undefined) {
    //     this.toggleLotPayment = params.lot;
    //
    //     console.log('toggleLotPayment',  this.toggleLotPayment);
    //
    //     if (this.toggleLotPayment) {
    //       this.loadPaymentLot(PaymentLotTypeLotEnum.BILLET);
    //     }
    //
    //   }
    // });

    /* Pega o titulo */
    const data: any = this.activatedRoute.snapshot.data;
    if (!(Object.keys(data).length === 0)) {
      this.titleHeader = data.type;
    }
  }

  loadUser(updateCheckDayResource?: boolean) {
    try {
      const userDetails = this.userInfoService.getInfoProfile();
      userDetails.then((user) => {
        this.userProfile = user;
        console.log(user);
        console.log('isRoleMenu BILLET_CHARGE_V2:: ' + user.isRoleMenu('BILLET_CHARGE_V21'));
        this.loadBalance(user.uuidWhiteLabel, user.uuidAccount);
        this.loadMyData(user);
        if (updateCheckDayResource) this.checkDayResource(user.uuidWhiteLabel, user.uuidAccount);
      });
    } catch (e) {
      console.error('Failed to load user details', e);
    }
  }

  public ngOnDestroy() {
    this.step2 = false;
    this.step3 = false;
    this.destroy$.next();
    this.destroy$.complete();
  }

  public f(control: string): AbstractControl {
    return this.billetForm.get(control);
  }

  public fResume(control: string): AbstractControl {
    return this.billetResumeForm.get(control);
  }

  public fExtract(control: string): AbstractControl {
    return this.billetResumeForm.get(control);
  }

  /**
   * Método responsavel por validar o Codigo de Barras e avançar para tela de confirmação
   */
  public validBarCode() {
    if (this.f('brCode').valid) {
      const lineConsult = this.f('brCode').value.replace(/[^0-9]/g, '');
      this.loadingService.show();
      this.service
        .getBillet(lineConsult, false, this.userProfile.uuidWhiteLabel, this.userProfile.uuidAccount)
        .pipe(
          takeUntil(this.destroy$),
          tap((res) => {
            this.service.formatData(
              res,
              this.userProfile.nameComplete,
              this.userProfile.nameBank,
              (this.userProfile as any).documentDefault,
            );

            this.consultBilletResponse = res;
            this.dateExpiration = res.dueDate;
            this.isDateExpirated = moment(res.dueDate).format();
            this.valuePayment = res.valuePayment;

            if (moment(this.dateExpiration).format() <= moment(this.initialDate).format()) {
              this.loadingService.hide();
              this.validateOperation();
            } else if (moment(this.dateExpiration).format() > moment(this.initialDate).format()) {
              this.step2 = true;
              this.changeStep2();
              this.loadingService.hide();
            } else {
              this.toastError();
              this.loadingService.hide();
            }
          }),
          catchError((_) => {
            this.toastError();
            this.loadingService.hide();
            return of(null);
          })
        )
        .subscribe();
    } else {
      this.toastError(this.translate.applyTranslate('CASH_OUT.BILLET.INVALID_CODE'));
    }
  }

  loadMyData(userProfile: UserInfoProfile) {
    this.myDataService
      .getAccountPaymentPerson(userProfile.uuidAccount)
      .pipe(
        tap((data) => {
          (this.userProfile as any).documentDefault = data.documentDefault;
        })
      )
      .subscribe();
  }

  public validateOperation() {
    this.loadingService.show();
    this.service
      .validateOperation(this.userProfile.uuidWhiteLabel, this.userProfile.uuidAccount, this.valuePayment)
      .then((res) => {
        this.loadingService.hide();
        if (!res) {
          this.statusBillet('warning-circle', 'CASH_OUT.BILLET_EXTRACT.MESSAGES.FAILED', true);
          return;
        } else {
          if (!res.isAllowed) {
            this.statusBillet('warning-circle', 'CASH_OUT.BILLET_EXTRACT.MESSAGES.FAILED_NOT_FUNDS', true);
            return;
          } else {
            this.step2 = true;
            this.changeStep2();
            return;
          }
        }
      })
      .catch((err) => {
        this.loadingService.hide();
        this.statusBillet('warning-circle', 'CASH_OUT.BILLET_EXTRACT.MESSAGES.FAILED', true);
      });
  }

  public async processPaymentLot() {
    if (this.toggleLotPayment) {
      const paymentBillet = new PaymentLotDetailBillet();
      paymentBillet.detail = this.consultBilletResponse;
      paymentBillet.typeableLine = this.consultBilletResponse.typeableLine;
      paymentBillet.valuePayment = +this.billetResumeForm.get('totalPay').value;
      paymentBillet.value = this.consultBilletResponse.valuePayment;
      paymentBillet.detail = this.consultBilletResponse;
      paymentBillet.descriptionOperation = 'Boleto de Cobrança';
      paymentBillet.datePayment = this.formattedPipeDate(this.billetResumeForm.get('datePay').value);

      await this.addTransactionOnLot(PaymentLotTypeLotEnum.BILLET, paymentBillet).subscribe(res => {
        this.step2 = false;
        this.step3 = false;

        this.loadPaymentLot(PaymentLotTypeLotEnum.BILLET);

      }, error => {
        console.error('ocorreu erro ao tentar adicionar item no lote', error);
        console.error('ocorreu erro ao tentar adicionar item no lote ' + (error as HttpErrorResponse).message );
        return this.statusBillet('warning-circle', 'CASH_OUT.PAYMENT_LOT.MESSAGES.ERROR_OPERATION_2', false);
      }, () => this.cdr.detectChanges() );
    } else {
      await this.confirmPayment();
    }
  }

  /**
   * Método responsavel por chamar um modal de confirmação de token e quando o retorno é true
   * aciona o serviço de confirmação de pagamento de boleto e redireciona para tela de de extrato.
   */
  public async confirmPayment() {
    this.listData1 = [
      { name: 'CASH_OUT.BILLET_RESUME.PAYMENT_DETAILS.PAYMENT_DATE', value: this.fResume('datePay').value },
    ];

    const modalToken = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION,
      },
    });
    modalToken.onDidDismiss().then((data) => {
      if (data.data) {
        const token = data['role'];
        this.loadingService.show();

        if (this.toggleLotPayment) {
          this.processPayment(PaymentLotTypeLotEnum.BILLET, token).then( res => {
            this.loadingService.hide();
          }, error => this.loadingService.hide());
        } else {
          this.service
            .saveBillet(this.billetResumeForm.value, this.userProfile.uuidWhiteLabel, this.userProfile.uuidAccount, token)
            .pipe(
              takeUntil(this.destroy$),
              tap((value) => {
                this.loadingService.hide();
                if (value !== null) {
                  if (value.isExecuted) {
                    if (value.approveFlow) {
                      return this.statusBillet('warning-circle', 'CASH_OUT.BILLET_EXTRACT.MESSAGES.REQUEST_APPROVAL', true);
                    } else if (value.scheduled && !value.approveFlow) {
                      this.transferScheduled = true;
                      this.titleExtract = this.translate.applyTranslate('CASH_OUT.BILLET_EXTRACT.DESCRIPTION_SCHEDULED');
                      return this.statusBillet('success', 'CASH_OUT.BILLET_EXTRACT.MESSAGES.SUCCESS_SCHEDULED', false, value.result.transactionId);
                    } else {
                      this.titleExtract = this.translate.applyTranslate('CASH_OUT.BILLET_EXTRACT.DESCRIPTION');
                      return this.statusBillet('success', 'CASH_OUT.BILLET_EXTRACT.MESSAGES.SUCCESS', false, value.result.transactionId);
                    }
                    this.step2 = false;
                    this.step3 = true;
                    this.changeStep3(value.result.transactionId, value.result.emitted);
                  } else if (!value.isExecuted) {
                    return this.statusBillet('warning-circle', value.message, false);
                  } else {
                    return this.statusBillet('warning-circle', 'CASH_OUT.BILLET_EXTRACT.MESSAGES.FAILED', false);
                  }
                } else {
                  return this.statusBillet('warning-circle', 'CASH_OUT.BILLET_EXTRACT.MESSAGES.FAILED', false);
                }
              }),
              catchError((_) => {
                this.loadingService.hide();
                return this.statusBillet('warning-circle', 'CASH_OUT.BILLET_EXTRACT.MESSAGES.FAILED', false);
                return of(null);
              }),
            )
            .subscribe();
        }
      }
    });

    return await modalToken.present();
  }

  private async showReceipt(data, voucherHTML) {
    const modal = await this.modalController.create({
      component: ModalExtractReviewComponent,
      cssClass: 'extract-review',
      componentProps: {
        confirmationData: data,
        isEmittedVoucher: !!voucherHTML,
        redirect: '/app/dashboard',
        voucherHTML,
      },
      backdropDismiss: false,
    });
    return await modal.present();
  }
  public async statusBillet(status: string, message: string, confirmation?: boolean, transactionId?: string) {
    this.loadingService.hide();

    const modalSuccess = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: status,
        message: message,
        confirmBtn: 'CASH_OUT.BILLET_RESUME.BUTTONS.CLOSE',
        confirmation: confirmation,
        translate: true,
      },
      backdropDismiss: false,
    });
    modalSuccess.onDidDismiss().then((data) => {
      console.log('data[data]', data['data']);
      if (data['data'] === true) {
        this.navCtrl.navigateRoot('/app/dashboard');
      } else {
        if (transactionId) {
          this.extractService.findTemplateVoucherByTransactionsId([transactionId]).subscribe((res) => {
            const voucherHTML: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(res[0].emittedVoucher);
            if (transactionId !== null || undefined) {
              return this.showReceipt(res[0], voucherHTML);
            } else {
              this.navCtrl.navigateRoot('app');
            }
          });
        } else {
          this.navCtrl.navigateRoot('app/payment/billet');
        }
      }
    });
    return await modalSuccess.present();
  }

 

  /**
   * Carregar as informações do passo 2
   */
  private changeStep2() {
    this.billetResumeForm.patchValue(this.service.getBilletResume());
    this.value = this.fResume('amountPaid').value.toLocaleString('pt-br', { minimumFractionDigits: 2 });
    this.editable = this.fResume('editable').value;
    this.maxPayment = this.fResume('maxPayment').value;
    this.minPayment = this.fResume('minPayment').value;

    this.initialDate = this.datesSchedule.dateStart;
    this.dateExpiration = this.fResume('dateExpiration').value;

    const formattedDateExpiration: string = this.dateExpiration && (this.dateExpiration + '').includes('/') ?  'DD/MM/YYYY' : 'YYYY-MM-DD';
    const formattedDateInitial: string = this.initialDate && (this.initialDate + '').includes('/') ?  'DD/MM/YYYY' : 'YYYY-MM-DD';

    if (moment(this.dateExpiration, formattedDateExpiration) <= moment(this.initialDate, formattedDateInitial)) {
      this.listData1 = [
        { name: 'CASH_OUT.BILLET_RESUME.PAYMENT_DETAILS.PAYMENT_DATE', value: this.fResume('datePay').value },
        { name: 'CASH_OUT.BILLET_RESUME.PAYMENT_DETAILS.BILLET_DUE_DATE', value: this.fResume('dateExpiration').value },
      ];
      this.billetExpireded = true;
    } else {
      this.initialDate = moment(this.initialDate).format('DD/MM/YYYY');
      this.listData1 = [
        { name: 'CASH_OUT.BILLET_RESUME.PAYMENT_DETAILS.BILLET_DUE_DATE', value: this.fResume('dateExpiration').value },
      ];
      this.configDatePicker();
      this.billetExpireded = false;
    }

    this.listData2 = [
      {
        name: 'CASH_OUT.BILLET_RESUME.PAYMENT_DETAILS.BENEFICIARY',
        value: this.fResume('nameBeneficiary').value,
      },
      this.billetResumeForm.get('discount').value
        ? {
          name: 'CASH_OUT.BILLET_RESUME.PAYMENT_DETAILS.DISCONT',
          value: this.billetResumeForm.get('discount').value.toLocaleString('pt-BR', { minimumFractionDigits: 2 }),
        }
        : null,
      this.billetResumeForm.get('fine').value
        ? {
          name: 'CASH_OUT.BILLET_RESUME.PAYMENT_DETAILS.FINE',
          value: this.billetResumeForm.get('fine').value.toLocaleString('pt-BR', { minimumFractionDigits: 2 }),
        }
        : null,
      this.billetResumeForm.get('interest').value
        ? {
          name: 'CASH_OUT.BILLET_RESUME.PAYMENT_DETAILS.INTEREST',
          value: this.billetResumeForm.get('interest').value.toLocaleString('pt-BR', { minimumFractionDigits: 2 }),
        }
        : null,
    ];

    if (this.fResume('bankBeneficiary').value) {
      this.listData2.push({
        name: 'CASH_OUT.BILLET_RESUME.PAYMENT_DETAILS.BENEFICIARY_BANK',
        value: this.fResume('bankBeneficiary').value,
      });
    }

    if (this.fResume('typeableLine').value) {
      this.listData2.push({
        name: 'CASH_OUT.BILLET_RESUME.PAYMENT_DETAILS.BILLET_CODE',
        value: this.fResume('typeableLine').value,
      });
    }
  }

  /**
   * Carregar as informações do passo 3
   */
  private changeStep3(transactionId: string, isEmittedVoucher: boolean) {
    if (!isEmittedVoucher) {
      this.extractService.getTransaction(transactionId).subscribe((res) => {
        this.isEmittedVoucher = false;
        this.paymentDataEmmittedVoucher = res;
        this.cdr.detectChanges()
      });
      /* this.billetExtractForm.patchValue(this.service.getBilletExtract()); */
     /*  this.data = {
        datePay: this.fExtract('datePay').value,
        amountPaid: this.fExtract('amountPaid').value,
        discount: this.fExtract('discount').value,
        interest: this.fExtract('interest').value,
        fine: this.fExtract('fine').value,
        totalPay: this.fExtract('totalPay').value,
        dateExpiration: this.fExtract('dateExpiration').value,
        transactionIdConsult: transactionId,
      };

      this.listData3 = [
        {
          name: this.translate.applyTranslate('CASH_OUT.BILLET_EXTRACT.BENEFICIARY_NAME'),
          value: this.fExtract('nameBeneficiary').value,
        },
      ];

      this.listData4 = [
        {
          name: this.translate.applyTranslate('CASH_OUT.BILLET_EXTRACT.BILLET_CODE_BAR'),
          value: this.fExtract('brCode').value,
        },
        {
          name: this.translate.applyTranslate('CASH_OUT.BILLET_EXTRACT.PAYER_NAME'),
          value: this.fExtract('namePayer').value,
        },
        { name: this.translate.applyTranslate('CASH_OUT.BILLET_EXTRACT.CPF'), value: this.fExtract('cpfPayer').value },
      ]; */
    } else {
      this.extractService.getTransactionv2(transactionId).subscribe((res) => {
        this.isEmittedVoucher = true;
        this.paymentDataEmmittedVoucher = res;
        this.cdr.detectChanges();
      });
    }

    // atualiza as informacoes de valores
    this.loadUser(false);
  }

  /**
   * Método para cancelar o pagamento de boleto
   */
  public cancel() {
    this.f('brCode').patchValue([]);
    this.step2 = false;
    this.navCtrl.navigateRoot('/app/dashboard');
  }

  /**
   * Método para verificar a alteração no valor quando o campo for editavel
   */
  public onChangeValue(event) {
    this.fResume('totalPay').patchValue(event);
  }

  /**
   * Método responsavel por imprimir o comprovante
   */
  public print(): void {
    /* let printContents: string;
    let css: string;
    printContents = document.getElementById('print-section').innerHTML;
   
    css = '<style> font-family: sans-serif; </style>';
    this.service.print(printContents, css); */
  }

  // METODO PARA EFETUAR UM NOVO PAGAMENTO
  public newPayment(): void {
    this.ngOnDestroy();
  }

  /**
   * Método responsavel por mostrar uma mensagem de erro quando o codigo
   * de barras informado é invalido
   */
  public async toastError(message?: string) {
    const toast = await this.toastController.create({
      message: message || this.translate.applyTranslate('CASH_OUT.BILLET.MESSAGES.FAILED'),
      duration: 2000,
      buttons: [
        {
          text: 'Fechar',
          role: 'cancel',
          handler: () => { },
        },
      ],
    });
    toast.present();
    this.ngOnDestroy();
  }

  /**
   * Métodos para o notificação e saldo
   */
  public onFlagActive() {
    this.flagDisplayNotification = false;
    this.flagDisplayCard = this.flagDisplayCard ? false : true;
  }

  public onFlagActiveNotification() {
    this.flagDisplayCard = false;
    this.flagDisplayNotification = this.flagDisplayNotification ? false : true;
  }

  private loadBalance(uuidWL: string, uuidAccount: string): void {
    this.balanceResponse = this.accountBalanceService
      .getBalance(uuidWL, uuidAccount)
      .then((res) => {
        this.headerService.updateValue(true); // atualiza os valores
        this.accountBalanceService.setBalanceSubject(res.balance);
      })
      .catch((err) => this.accountBalanceService.getErroMessage(err));
  }

  public showBalance() {
    if (this.iconName === 'eye-off-outline') {
      this.iconName = 'eye-outline';
      this.showBLC = true;
    } else {
      this.iconName = 'eye-off-outline';
      this.showBLC = false;
    }
  }

  goBack() {
    this.navCtrl.navigateRoot('/app/dashboard');
  }

  private checkDayResource(uuidWhiteLabel, uuidAccount) {
    this.transferService.checkDayResource(uuidWhiteLabel, this.OPERATION, this.PERMIT_OPERATION).subscribe(
      (res) => {
        this.param = {
          startTime: res.startTime,
          endTime: res.endTime,
        };
        this.permitTransaction = res.dateValid;

        if (!this.permitTransaction) this.validateTime();
      },
      (error) => console.error(error),
      () => {
        // let arrayDate = this.dateExpiration.split('-');
        // let date = moment(`${arrayDate[1]}-${arrayDate[0]}- ${arrayDate[2]}`).format('YYYY-MM-DDTh:mm');

        this.transferService.checkDayResource(uuidWhiteLabel, this.OPERATION, '1').subscribe((res) => {
          this.datesSchedule = res;
        });
      }
    );
  }

  public onSelectedDate(dateSelected: any) {
    if (this.newUTCDate(dateSelected) === this.newUTCDate(this.initialDate)) {
      this.dateTransfer = this.datesSchedule.dateStart;
      this.billetResumeForm.get('dateSchedule').setValue(this.dateTransfer);
      this.billetResumeForm.get('scheduled').setValue(this.permitTransaction ? false : true);
      this.billetResumeForm.get('datePay').setValue(moment(this.dateTransfer).format('DD/MM/YYYY'));

      if (!this.permitTransaction) {
        if (this.toggleLotPayment) {
          this.changeTextAction();
        } else {
          this.textActionButton = 'CASH_OUT.BILLET_RESUME.BUTTONS.SCHEDULE';
        }
        this.titleHeader = 'CASH_OUT.BILLET_RESUME.HEADER.TITLE_SCHEDULE';
      }
      return;
    }

    if (this.newUTCDate(dateSelected) !== this.newUTCDate(this.initialDate)) {
      let dateFormat: any = dateSelected.replaceAll('/', '-').split('-').reverse().toString().replaceAll(',', '-');
      this.dateTransfer = dateFormat;
      this.billetResumeForm.get('scheduled').setValue(true);
      this.billetResumeForm.get('dateSchedule').setValue(this.dateTransfer);
      this.billetResumeForm.get('datePay').setValue(moment(this.dateTransfer).format('DD/MM/YYYY'));
      if (this.toggleLotPayment) {
        this.changeTextAction();
      } else {
        this.textActionButton = 'CASH_OUT.BILLET_RESUME.BUTTONS.SCHEDULE';
      }
      this.titleHeader = 'CASH_OUT.BILLET_RESUME.HEADER.TITLE_SCHEDULE';
      return;
    }
  }

  protected changeTextAction() {
    if (this.toggleLotPayment) {
      this.textActionButton = 'CASH_OUT.PAYMENT_LOT.BUTTONS.ADD';
    } else {
      this.textActionButton = 'CASH_OUT.BILLET_RESUME.BUTTONS.PAY';
    }
  }

  private newUTCDate(date: any) {
    return moment(date.replaceAll('/', '-').split('-').reverse().toString().replaceAll(',', '-')).format();
  }

  private configDatePicker() {
    this.datePickerConfig = {
      editable: false,
      locale: this.langDefault != 'zh' ? this.langDefault : 'zh-hk',
      format: 'DD/MM/YYYY',
      firstDayOfWeek: 'su',
      disableKeypress: true,
      min: moment(this.datesSchedule.dateStart).format('DD/MM/YYYY'),
      max: moment(this.datesSchedule.dateEnd).format('DD/MM/YYYY'),
      isDayDisabledCallback: (Moment) => this.dayDates(Moment),
    };
    this.billetExpireded = true;
  }

  private dayDates(day) {
    this.disableDays = moment(day).format('YYYY-MM-DD');
    this.isValidDay = moment(day._d).format()


    if (day._d.getTime() < Date.parse(this.datesSchedule.dateStart)) return true;
    if (day._d.getTime() > Date.parse(this.datesSchedule.dateEnd)) return true;

    if(this.isValidDay > this.isDateExpirated) return true
    
    if (this.datesSchedule.dateException.indexOf(this.disableDays) == -1) return false;
    else return true;
  }

  private async validateTime() {
    const modalStatus = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-validate-time',
      componentProps: {
        status: 'warning-circle',
        message: 'CASH_OUT.BILLET.MESSAGES.VALIDATE_TIME.DESCRIPTION.PRIMARY',
        description: 'CASH_OUT.BILLET.MESSAGES.VALIDATE_TIME.DESCRIPTION.SECONDARY',
        confirmBtn: 'CASH_OUT.BILLET.MESSAGES.VALIDATE_TIME.BUTTON.CONFIRM_BUTTON',
        cancelBtn: 'CASH_OUT.BILLET.MESSAGES.VALIDATE_TIME.BUTTON.CANCEL_BUTTON',
        confirmation: true,
        translate: true,
        param: this.param,
      },
      backdropDismiss: false,
    });
    modalStatus.onDidDismiss().then((data) => {
      if (data.data === false) {
        this.navCtrl.navigateRoot('app/dashboard');
      }
    });
    return await modalStatus.present();
  }

  async openModalTaxes() {    
    const modalStatus = await this.modalController.create({
      component: ModalAlertBilletTaxesComponent,
      cssClass: 'modal-validate-taxes',
      componentProps: {
        status: '',
        message: 'Tributos aceitos',
        description: 'CASH_OUT.BILLET.DESCRIPTION_TAXES.TYPES_TAXES',
        confirmBtn: 'CASH_OUT.BILLET.DESCRIPTION_TAXES.BUTTON_CLOSE',
        confirmation: false,
        notButtons:false,
        translate: true,
        param: this.param,
      },
      backdropDismiss: false,
    });
    return await modalStatus.present();
  }
}
